import { useLocation } from 'react-router-dom';
import { MainLayout } from './MainLayout';

/**
 * Wraps page content in MainLayout for global routes.
 * Detects championship context from the URL:
 *   /championships/:id/*  → no MainLayout (Sidebar already provides it)
 *   /central-desk, etc.   → MainLayout (global sidebar)
 *
 * This works for both:
 * - Pages rendered inside ChampionshipLayout (Outlet context)
 * - Pages rendered as standalone championship sub-routes (/championships/:id/...)
 */
export function PageContent({ children, fullWidth = false }) {
  const location = useLocation();
  const inChampionshipContext = /^\/championships\/[a-f0-9]{24}/.test(location.pathname);

  if (inChampionshipContext) {
    return <>{children}</>;
  }

  return <MainLayout fullWidth={fullWidth}>{children}</MainLayout>;
}
